import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserProfileData } from "../..";
import { CheckUtils } from "../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n<div *ngIf=\"data !=null\" class=\"od-user-profile\">\n\t<od-decorated-avatar class=\"od-user-profile-decorated-avatar\" *ngIf=\"data.decoratedAvatarData !=null\"\n\t [data]=\"data.decoratedAvatarData\"></od-decorated-avatar>\n\t \n\t<div class=\"od-user-profile-form\">\n\t\t<div class=\"od-user-profile-name\">{{getValue(data.firstName)}} {{getValue(data.lastName)}} </div>\n\t\t<div class=\"od-user-profile-info\">\n\t\t\t<div style=\"text-transform: capitalize;\">{{getValue(data.organization)}} </div>\n\t\t\t<div>{{getValue(data.email)}} </div>\n\t\t</div>\n\t\t<od-button class=\"od-user-profile-form-sign-out\" [text]=\"'UserProfile.signOut' | translate\" [color]=\"buttonTextColor\" [bgColor]=\"buttonColor\"  (click)=\"onSignOut()\" [size]=\"'300px'\" [iconName]=\"odi_signOut\"></od-button>\n\t</div>\n</div>\n";
var CSS_STYLE = "\n.od-user-profile {\n\tdisplay:flex;\n\tflex-direction:column;\n}\n\n.od-user-profile-decorated-avatar{\n\tmargin: 20px 0 10px 0;\n    justify-content: center;\n    display: flex;\n}\n    \n.od-user-profile-form{\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    align-items: center;\n}\n\n.od-user-profile-form > *{\n\tpadding-bottom: 12px;\n\twidth:fit-content;\n}\n\n.od-user-profile-name{\n\tfont-family: Lato;\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tline-height: 1.2;\n\tletter-spacing: normal;\n\ttext-align: center;\n\tcolor: #354052;\n}\n\n.od-user-profile-info{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px 0;\n\tfont-family: Lato;\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tfont-style: normal;\n\tfont-stretch: normal;\n\tline-height: 1.14;\n\tletter-spacing: normal;\n\ttext-align: center;\n\tcolor: #9a9fa8;\n}\n\n.od-user-profile-info > * {\n\tpadding-bottom:5px;\n}\n\n.od-user-profile-form > .od-user-profile-form-sign-out{\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    margin-top:20px;\n}\n\n";
var UserProfile = /** @class */ (function () {
    function UserProfile() {
        this.odSignOut = new EventEmitter();
        if (this.buttonColor == null)
            this.buttonColor = "#25aed8";
        if (this.buttonTextColor == null)
            this.buttonTextColor = "#FFFFFF";
    }
    Object.defineProperty(UserProfile.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
            if (this._data != null && this._data.decoratedAvatarData != null) {
                this._data.decoratedAvatarData.hideStatus = true;
                this._data.decoratedAvatarData.hideType = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    UserProfile.prototype.getValue = function (value) {
        return CheckUtils.isEmpty(value) ? '' : value;
    };
    UserProfile.prototype.onSignOut = function () {
        this.odSignOut.emit();
    };
    UserProfile.decorators = [
        { type: Component, args: [{
                    selector: 'od-user-profile',
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    UserProfile.ctorParameters = function () { return []; };
    UserProfile.propDecorators = {
        "buttonTextColor": [{ type: Input },],
        "buttonColor": [{ type: Input },],
        "odSignOut": [{ type: Output },],
        "data": [{ type: Input },],
    };
    return UserProfile;
}());
export { UserProfile };
//# sourceMappingURL=user-profile.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/sign/user-profile.js
// module id = 444
// module chunks = 14